import yup from "src/validators/yup.Module";

export interface CategoriasFiltrarDto {
  id: number;
  nome: string;
}

export const CategoriasFiltrarSchema = yup.object().shape({
  nome: yup
    .string()
    .notRequired()
    .min(3, "O nome deve ter no mínimo 3 caracteres"),
});
